import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, nextTick, onMounted } from 'vue';
import { textareaProps, textareaEmits } from './textarea';
import { UPDATE_MODEL_VALUE } from '../../constants';
import { UiIconClose, UiIconDeleteOutline } from '../../icons';
import createComponentId from '../../utils/createComponentId';


const __default__ = {
    name: 'UiTextarea',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: textareaProps,
  emits: textareaEmits,
  setup(__props, { expose, emit: emits }) {

const props = __props




const textareaRef = ref<HTMLTextAreaElement>();
const textareaId = createComponentId('ui-textarea');

const isInnerClearVisible = computed<boolean>(
    () => props.clearable === true && !!props.modelValue?.length,
);

const modifiers = computed<(string | false | undefined)[]>(() => [
    'ui-textarea',
    props.size && `--${props.size}`,
    props.view && `--${props.view}`,
    props.resize && `--resize`,
    props.disabled && '--disabled',
    props.readonly && '--readonly',
    props.autosize && '--autosize',
    isInnerClearVisible.value && '--clearable-inner',
]);

const effectiveRows = computed(() => props.autosize ? (props.rows ?? 1) : props.rows);

const fieldStyle = computed<Record<string, string>>(() => ({
    resize: props.autosize ? 'none' : (props.resize ?? 'none'),
    ...(props.rows && !props.autosize ? { height: 'auto' } : {}),
}));

const syncHeight = (): void => {
    const el = textareaRef.value;
    if (!el || !props.autosize) return;
    el.style.height = 'auto';
    el.style.height = `calc(${el.scrollHeight}px - 2px)`;
};

const handleInput = (event: Event): void => {
    if (props.disabled || props.readonly) return;
    const value = (event.target as HTMLTextAreaElement).value;
    emits(UPDATE_MODEL_VALUE, value);
    emits('input', value);
    syncHeight();
};

const handleFocus = (event: Event): void => {
    emits('focus', (event.target as HTMLTextAreaElement).value);
};

const handleBlur = (event: Event): void => {
    emits('blur', (event.target as HTMLTextAreaElement).value);
};

const handleChange = (event: Event): void => {
    if (props.disabled || props.readonly) return;
    emits('change', (event.target as HTMLTextAreaElement).value);
};

const handleClear = (): void => {
    if (props.disabled || props.readonly) return;
    emits(UPDATE_MODEL_VALUE, '');
    emits('input', '');
    emits('change', '');
    emits('clear', '');
    nextTick(syncHeight);
};

onMounted(() => {
    syncHeight();
});

watch(() => [props.modelValue, props.size], () => {
    nextTick(syncHeight);
});

expose({ textareaRef });

return { __sfc: true,props, emits, textareaRef, textareaId, isInnerClearVisible, modifiers, effectiveRows, fieldStyle, syncHeight, handleInput, handleFocus, handleBlur, handleChange, handleClear, UiIconClose, UiIconDeleteOutline }
}

})